export const DATA_ACTION_TYPES = {
    // Define Action types
    SET_MENU_ENABLED: "SET_MENU_ENABLED"
};
export const setMenuEnabled = (menuEnabled) => ({ 
    type: DATA_ACTION_TYPES.SET_MENU_ENABLED, 
    payload:menuEnabled
}); 